import { ModuleType, ObjectTypes } from '@fi-shared/types';

export class StatisticToObjectVisitModel {
    SessionId: string;
    ObjectId: number;
    ObjectType: ObjectTypes;
    ModuleType: ModuleType;
    StartTime: Date;
    EndTime: Date;
    IsInCurrentModule: boolean;

    constructor(userTokenId: string, moduleType?: ModuleType, objectType?: ObjectTypes, objectId?: number) {
        this.SessionId = userTokenId;
        this.ObjectType = objectType;
        this.ObjectId = objectId;
        this.ModuleType = moduleType;
        this.StartTime = new Date();
        this.EndTime = new Date();
        this.IsInCurrentModule = true;
    }

    Initialize(objectVisit?: StatisticToObjectVisitModel) {
        if (objectVisit) {
            this.SessionId = objectVisit.SessionId;
            this.ObjectId = objectVisit.ObjectId;
            this.ObjectType = objectVisit.ObjectType;
            this.ModuleType = objectVisit.ModuleType;
            this.StartTime = objectVisit.StartTime;
            this.EndTime = objectVisit.EndTime;
            this.IsInCurrentModule = objectVisit.IsInCurrentModule;
        }
    }
}
